"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deserializeHxInstallAddInResults = void 0;
function deserializeHxInstallAddInResults(values) {
    var i = 0;
    var id = values[i++];
    var versionId = values[i++];
    var displayName = values[i++];
    var descriptionString = values[i++];
    var providerName = values[i++];
    var iconUrl = values[i++];
    var highResolutionIconUrl = values[i++];
    var type = values[i++];
    var enabled = values[i++];
    var licenseStatus = values[i++];
    var requirements = values[i++];
    var consentState = values[i++];
    if (i != values.length) {
        throw "Result values not parsed completely";
    }
    return { id: id, versionId: versionId, displayName: displayName, descriptionString: descriptionString, providerName: providerName, iconUrl: iconUrl, highResolutionIconUrl: highResolutionIconUrl, type: type, enabled: enabled, licenseStatus: licenseStatus, requirements: requirements, consentState: consentState };
}
exports.deserializeHxInstallAddInResults = deserializeHxInstallAddInResults;
